<section class="bg-[#1C1E22] py-[60px] lg:py-[100px]">
  <div class="container">
    <div
      class="flex flex-col items-start gap-[20px] rounded-[10px] border border-solid border-white/30 bg-[#25282D] px-[20px] py-[32px] lg:flex-row lg:items-center lg:justify-between lg:px-[40px] lg:py-[44px]"
    >
      <div class="flex flex-col gap-[10px]">
        <h2 class="text-[24px] font-medium leading-[1.3] text-white lg:text-[28px]">
          {{ heading() }}
        </h2>
        <p class="max-w-[640px] text-[16px] leading-[1.8] text-[#C0C0C0]">{{ text() }}</p>
      </div>
      <a
        [href]="appLinks.createAccountHref()"
        target="_blank"
        class="btn btn-white btn-with-arrow min-h-[52px] w-full max-w-[280px] rounded-[8px] font-harmony font-medium leading-[18px]"
      >
        <span class="text-[16px] tracking-[0.3px]">Open Business Account</span>
        <mat-icon
          svgIcon="second-arrow-right"
          class="ml-[13px] mr-[5px] max-h-[14px] max-w-[16px] text-black"
        ></mat-icon>
      </a>
    </div>
  </div>
</section>
